// src/components/AuthPages/ResetPassword.jsx  →  /reset-password?token=...
// Lee el token del link del email, pide la nueva contraseña y llama /api/reset-password.
import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FiEye, FiEyeOff, FiCheck } from 'react-icons/fi';
import './AuthPages.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [showPw, setShowPw]     = useState(false);
  const [loading, setLoading]   = useState(false);
  const [done, setDone]         = useState(false);
  const [error, setError]       = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8)      { setError('La contraseña debe tener al menos 8 caracteres.'); return; }
    if (password !== confirm)     { setError('Las contraseñas no coinciden.'); return; }
    setLoading(true);
    try {
      const res  = await fetch(`${API_URL}/api/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'No se pudo actualizar la contraseña.');
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2500);
    } catch (err) {
      setError(err.message === 'Failed to fetch' ? 'No se pudo conectar al servidor.' : err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ap-wrap">
      <div className="ap-card">
        <img src="/assets/Logo-White.png" alt="Bitplify" className="ap-logo" />
        <h1 className="ap-title">Nueva contraseña</h1>

        {!token ? (
          <>
            <div className="ap-msg err">Enlace inválido o incompleto. Pedí uno nuevo desde “¿Olvidaste tu contraseña?”.</div>
            <p className="ap-foot"><Link className="ap-link" to="/forgot">Pedir un enlace nuevo</Link></p>
          </>
        ) : done ? (
          <>
            <div className="ap-msg ok"><FiCheck /> ¡Contraseña actualizada! Te llevamos a iniciar sesión…</div>
            <p className="ap-foot"><Link className="ap-link" to="/login">Ir a iniciar sesión ahora</Link></p>
          </>
        ) : (
          <>
            <p className="ap-sub">Elegí tu nueva contraseña. El enlace vence en 30 minutos.</p>
            <form onSubmit={submit}>
              <div className="ap-field">
                <label className="ap-label">Nueva contraseña</label>
                <div style={{ position: 'relative' }}>
                  <input
                    className="ap-input" type={showPw ? 'text' : 'password'} placeholder="Mínimo 8 caracteres"
                    value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password"
                    style={{ paddingRight: 44 }}
                  />
                  <button type="button" onClick={() => setShowPw(s => !s)} tabIndex={-1}
                    style={{ position: 'absolute', right: 8, top: 0, height: '100%', background: 'none', border: 'none', color: '#7a8a9a', cursor: 'pointer' }}>
                    {showPw ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>
              <div className="ap-field">
                <label className="ap-label">Confirmar contraseña</label>
                <input
                  className="ap-input" type="password" placeholder="Repetí la contraseña"
                  value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password"
                />
              </div>
              {error && <div className="ap-msg err">{error}</div>}
              <button type="submit" className="ap-btn" disabled={loading}>
                {loading ? <span className="ap-spin" /> : 'Cambiar contraseña'}
              </button>
            </form>
            <p className="ap-foot"><Link className="ap-link" to="/login">Volver a iniciar sesión</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
